import { ILogisticsDataRes } from "./types";

export const ActionTypes = {
    SET_LOGISTIC_LIST: "SET_LOGISTIC_LIST",
};
export const setLogisticList = (payload: ILogisticsDataRes) => ({
  type: ActionTypes.SET_LOGISTIC_LIST,
  payload,
});
